<template>
    <div id="paper-root" style="max-width: 1200px;margin: 0 auto;width: 100%;min-height: calc(100vh - 50px);">
        <template v-if="paperQuestion.length > 0">
            <a-layout theme="light" class="paper-style-2" style="min-height: calc(100vh - 70px);margin-top: 20px;">
                <a-layout>

                    <a-layout-content>
                        <div class="paper-content" :bordered="false">
                            <div class="paper-content-item" v-show="qi == currentQuestionIndex"
                                v-for="(q, qi) in paperQuestion" :key="qi">
                                <a-row>
                                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <a-card class="stem-card" :bordered="false"
                                            :headStyle="{ 'background': '#c8c8c84a' }"
                                            :bodyStyle="{ 'background': '#c8c8c84a' }">
                                            <span slot="title">
                                                <p style="white-space:initial">题目：{{ title }}</p>
                                                <span style="font-size: 12px;">记录时间：{{ q.createTime }}</span>
                                            </span>
                                            <div class="question-stem">
                                                <p style="float: left;"> {{ qi + 1 }}、</p>
                                                <div style="float: left;" v-html="q.comment"
                                                    :id="'question-stem-' + q.id">
                                                </div>
                                            </div>
                                            <div class="question-opt-btn">
                                                <div class="switch-btn">
                                                    <a-button class="prevBtn" type="primary" @click="prevQuestion()" v-show="currentQuestionIndex != 0">上一条</a-button>
                                                    <a-button class="nextBtn" type="primary" @click="nextQuestion()" v-show="currentQuestionIndex != paperQuestion.length - 1">下一条</a-button>
                                                </div>
                                            </div>
                                        </a-card>
                                    </a-col>
                                </a-row>
                            </div>

                        </div>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </template>
        <template v-else>
            <div style="margin-top: 50px;">
                <a-empty description="暂无数据" />
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'

export default {
    name: 'Examine',
    mixins: [mixinDevice, jumpMixins, examMixins],
    components: {
        JModal,
        Voice
    },
    data() {
        return {
            paperQuestion: [],
            currentQuestionIndex: 0,
            dataInfo:{},
            title:''
        }
    },
    watch: {},
    created() {
        let that = this
        this.routeInfo = this.$route.query
        this.requestMyPaperQuestionInfo(true) //获取试卷列表
        //拦截未登录
        if (!this.$store.getters.userInfo) {
            this.$info({
                title: that.$t('sys.notLogin'),
                content: that.$t('exam.pleaseToLogin'),
                okText: that.$t('sys.toLogin'),
                onOk() {
                    that.toLogin()
                },
            });
            // return
        } else {
            console.log("userInfo", this.$store.getters.userInfo);
        }
    },
    mounted() {
        var that = this
        document.title = this.$route.query.name
    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    //离开页面
    beforeDestroy() {

    },
    methods: {
        upload2Qiniu: upload2Qiniu,
        dataURLtoBlob: dataURLtoBlob,
        //请求答题卡和题目
        requestMyPaperQuestionInfo(status=false) {
            const data = {
                pageNo: this.pageNo,
                pageSIze: 10,
                sourceType: 4
            }
            getAction('/teaching/comment/myCommentList', data).then((res) => {
                if (res.success && res.result != null) {
                    this.dataInfo = res.result
                    this.paperQuestion = res.result.records
                    if(status)this.getTitleFn(res.result.records[0].sourceId) 
                } else {
                    this.$message.error(res.message)
                    this.userPaperId = ''
                }
            })
        },
        nextQuestion() {
            let _this = this
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == this.paperQuestion.length - 1) {
                return
            }
            this.currentQuestionIndex++
            this.getTitleFn()
            if (this.currentQuestionIndex == (this.paperQuestion.length - 2) && this.pageNo < this.dataInfo.pages) {
                _this.pageNo++
                _this.requestMyPaperQuestionInfo(_this.$route.query)
            }

        },
        prevQuestion() {
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == 0) {
                return
            }
            this.currentQuestionIndex--
            this.getTitleFn()
        },
        getTitleFn(){
            getAction('/teaching/teachingQuestion/getQuestion?questionId='+this.paperQuestion[this.currentQuestionIndex].sourceId).then(res=>{
                console.log(res)
                if(res.success){
                    this.title = res.result.questionStem
                }
            })
        },

    },
}
</script>

<style lang="less" scoped>
@import url('../../assets/exam.less');
</style>
